import { Pipe, PipeTransform } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Pipe({
  name: 'validationMessage',
  standalone: true,
  pure: false
})
export class ValidationMessagePipe implements PipeTransform {
  transform(control: AbstractControl | null): string {
    if (!control || !control.errors) {
      return '';
    }

    const errors = control.errors;
    
    for (const key in errors) {
      if (errors[key] && typeof errors[key] === 'object' && 'message' in errors[key]) {
        return (errors[key] as { message: string }).message;
      }
    }
    
    return '';
  }
}
